export { default } from "./spinner.svelte";
